Whether there is a next page of results at the time of retrieval.
